<template>
	<div class="p_box" id="box">
		<div id="head">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item :to="{ path: '/Homet' }" replace>首页</el-breadcrumb-item>
				<el-breadcrumb-item>个人信息</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="mine_list p_m_t_30 overflow small_hand" :style="{ height: height + 'px' }">
			<div class=" user_box ">
				<span class="type_size_22">{{name}}</span>
				<div class="p_m_t_20" >
						<template v-for="item in arr">
							<el-tag type="success" class="names" effect="dark" size="small">{{item.name}}</el-tag>
						</template>
				</div>
				<div class="p_flex p_f_a p_f_b p_m_t_30">
					<span class="type_size_20">修改密码</span>
					<el-button  @click='goPassword' type="success" size="small" plain>修改</el-button>
				</div>
				<div class="p_flex p_f_b p_m_t_30">
					<span class="type_size_20">{{phone?"更改手机号":"绑定手机号"}}</span>
					<div class="p_flex p_f_a">
						<span class="p_m_r_30">{{phone?(phone + '').substr(0,3) + '****' +phone.substr(7):""}}</span>
						<el-button @click='goMobile' type="success" size="small" plain>修改</el-button>
					</div>
				</div>
				<div class="p_flex p_f_b p_f_a p_m_t_30" @click="goSetting">
					<span class="type_size_20">{{num==1?"更改密保":"设置密保"}}</span>
					<el-button type="success" size="small" plain>设置</el-button>
				</div>
			</div>
		</div>
		<user-password :password='password' @closesp='closesp' @goButtonp='goButtonp'></user-password>
		<user-mobile :mobile="mobile" @closesm='closesm' @goButtonm='goButtonm'></user-mobile>
	</div>
</template>

<script>
import UserPassword from './commponents/password.vue'
import UserMobile from './commponents/mobile.vue'
export default {
	name: 'User',
	components:{
		UserPassword,
		UserMobile
	},
	data() {
		return {
			height: 0,
			password:false,
			mobile:false,
			name:"", //名字
			arr:[], //班级
			phone:"", //手机号
			account:"", //账号
			num:"" //判断是否密保问题存在
		};
	},
	mounted() {
		this.indexInfo();
		var userInfo = JSON.parse(localStorage.getItem('user'));
		// console.log(userInfo)
		this.name=userInfo.name
		this.arr=userInfo.class_level_def
		this.phone=userInfo.phone
		this.account=userInfo.account
		this.get()
	},
	watch: {
		'$route.path': {
			immediate: true,
			handler(newVal, oldVal) {
				if (newVal == '/User') {
					var height = localStorage.getItem('height');
					if (height == '') {
					} else {
						this.height = height;
					}
				}
			}
		}
	},
	beforeRouteLeave(to, form, next) {
		localStorage.removeItem('height');
		next();
	},
	methods: {
		get(){
			this.$request.ajax(this).post("/api/security_question",{
				account:this.account,
				user_type: localStorage.getItem('userInfo')==0?"teacher":"student"
			}).then(res=>{
				//  console.log(res)
				if(res.data.length!=0){
					this.num=1  //存在
				}else{
					this.num=0  // 不存在
				}
			})
		},
		indexInfo() {
			var box = document.getElementById('box').offsetHeight;
			var head = document.getElementById('head').offsetHeight;
			var height = box - head - 30;
			var heights = localStorage.getItem('height');
			if (heights == null) {
				localStorage.setItem('height', height);
			} else {
			}
			this.height = height;
		},
		goSetting(){
			this.$router.push('/Setting');
		},
		goPassword(){
			this.password = true
		},
		closesp(val){
			this.password = val
		},
		goButtonp(val){
			this.password = val
		},
		goMobile(){
			this.mobile = true
		},
		closesm(val){
			this.mobile = val
		},
		goButtonm(val){
			this.mobile = val
		}
	}
};
</script>

<style lang="scss" scoped>
.names{
	margin: 0 10px 0 0;
}
.mine_list {
	background: #ffffff;
}
.user_box {
	padding: 30px 260px;
}
>>> .el-tag--dark.el-tag--success {
	background-color: #00af63;
	border-color: #00af63;
}
</style>



// WEBPACK FOOTER //
// src/components/homet/user/index.vue